import React, { useState } from 'react';
import './css/index.scss';
import { useDispatch } from 'react-redux';
import MyModal from '../../../../components/MyModal';
import { USER_MODAL_STATES } from '../../constants';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import sendRequest from '../../../../helpers/sendRequest';
import { removeUser, updateUsers } from '../../../../store/actions/users';
import useInputState from '../../../../helpers/hooks/useInputState';
import { removeOrganization } from '../../../../store/actions/organizations';

function UserModal({
  isVisible, setIsVisible, modalState, selectedUser = {}, setSelectedUser,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    if (loading) {
      return;
    }
    setIsVisible(false);
    setTimeout(() => {
      setSelectedUser({});
    }, 400);
  };

  const onActiveChange = (newActiveVal) => async () => {
    const payload = {
      user_id: selectedUser._id,
      is_active: newActiveVal,
    };

    const data = await sendRequest({
      request: Api.blockUser,
      payload,
      warnErrorText: 'while blocking user',
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(updateUsers({ ...selectedUser, is_active: newActiveVal }));
      closeModal();
    }
  };

  const onDeleteClick = async () => {
    const data = await sendRequest({
      request: Api.deleteUser,
      payload: { id: selectedUser._id },
      warnErrorText: 'while deleting user',
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(removeUser({ ...selectedUser }));
      closeModal();
    }
  };

  return (
    <MyModal isOpen={isVisible} closeFunction={closeModal}>
      <div className="user_modal">
        {modalState === USER_MODAL_STATES.block ? (
          <>
            <p className="modal_title">Забанить?</p>
            <p className="modal_info_name">{selectedUser.display_name}</p>
            <p className="modal_info">Вы уверены что хотите отправить этого пользователя в бан-лист?</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Забанить"
                loading={loading}
                onClick={onActiveChange(false)}
              />
            </div>
          </>
        ) : modalState === USER_MODAL_STATES.makeActive ? (
          <>
            <p className="modal_title">Разбанить?</p>
            <p className="modal_info_name">{selectedUser.display_name}</p>
            <p className="modal_info">Вы уверены что хотите снять этого пользователя из бан-листа?</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Разбанить"
                loading={loading}
                onClick={onActiveChange(true)}
              />
            </div>
          </>
        ) : modalState === USER_MODAL_STATES.fullyDelete ? (
          <>
            <p className="modal_title">Удалить?</p>
            <p className="modal_info_name">{selectedUser.display_name}</p>
            <p className="modal_info">Вы уверены что хотите удалить этого пользователя? Сразу удалятся абсолютно все сущности, связанные с ним</p>
            <p className="modal_info">Отменить данное действие будет невозможно</p>

            <div className="modal_buttons_row">
              <MyButton className="modal_button" text="Отмена" secondary onClick={closeModal} />
              <MyButton
                className="modal_button"
                text="Удалить"
                loading={loading}
                onClick={onDeleteClick}
              />
            </div>
          </>
        ) : null}
      </div>
    </MyModal>
  );
}

export default UserModal;
